import { Station } from './station.class';
import { User } from './user.class';
import { Picture } from './picture.interface';

interface Control {
  label: string;
  done: boolean;
  visaTech: string;
  visaClient: string;
  okLabel: string;
  koLabel: string;
}

interface TechInfo {
  arrival: Date;
  leave: Date;
  driveDuration: number;
}

interface WorkDone {
  tech: TechInfo;
  description: string;
}

interface WorkToDo {
  description: string;
  visaTech: string;
  visaClient: string;
}

interface InterventionJSON {
  type: string;
  typeOther: string;
  date: Date;
  callHour: string;
  expertAssessmentERE: string;
  workDone: WorkDone;
  workToDo?: WorkToDo;
  checks?: Control[];
}

export class Intervention {
  public id?: string;
  public type: string;
  public typeOther: string;
  public date: Date;
  public json: InterventionJSON;
  public pictures: Picture[];
  public By?: User;
  public ById?: string;
  public Station?: Station;
  public StationId?: string;

  constructor(obj?: any) {
    const data = {
      pictures: [],
      ...(obj || {})
    };

    this.id = data.id;
    this.date = data.date;
    this.type = data.type;
    this.typeOther = data.typeOther;
    this.json = data.json;
    this.pictures = data.pictures ? data.pictures.map((picture) => {
      if(typeof picture === 'string') return { id: picture };
      else return picture;
    }) : [];

    if (data.By) {
      this.By = new User(data.By);
    }

    if (data.Station) {
      this.Station = new Station(data.Station);
    }
  }

  public get typeLabel() {
    let typeFound = Intervention.Types
      .find((type) => type.key === this.type);

    if (!typeFound) return 'inconnu';

    if (typeFound.key === 'OTHER') {
      return typeFound.label + ' (' + this.typeOther + ')';
    }
    return typeFound.label;
  }

  public static Types = [
    { key: 'MAINTENANCE', label: 'MAINTENANCE CORRECTIVE' },
    { key: 'FIX', label: 'DEPANNAGE' },
    { key: 'CONSTRAINT', label: 'ASTREINTE' },
    { key: 'OTHER', label: 'AUTRE' },
  ]
}



// WEBPACK FOOTER //
// ./src/app/models/intervention.class.ts